import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import { visibilitySettings } from '../../../utils';
import BackstageAlbumGridItem from '../../BackstageAlbumGridItem';

const LatestReleaseGridItemWithLogger = D.withVisibilityLogger(
  { contentSection: BackstageConstants.BackstageSections.LATEST_RELEASE },
  visibilitySettings({ isGridComponent: true }),
)(BackstageAlbumGridItem);

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const ArtistLatestReleaseGridItem = props => {
  const { pandoraId, isRightRailActive } = props;
  return (
    <D.ContentSection
      isLatestRelease={true}
      title={<FormattedMessage {...BackstageConstants.messages.latestRelease} />}
    >
      <D.AppContextIntegrationData
        data={{
          contentSection: BackstageConstants.BackstageSections.LATEST_RELEASE,
          pandoraId,
        }}
      >
        <LatestReleaseGridItemWithLogger
          // @ts-expect-error TS(2322) FIXME: Type '{ pandoraId: any; twoColumns: boolean; isFlu... Remove this comment to see the full error message
          pandoraId={pandoraId}
          twoColumns={!isRightRailActive}
          isFluid={true}
        />
      </D.AppContextIntegrationData>
    </D.ContentSection>
  );
};

ArtistLatestReleaseGridItem.propTypes = {
  pandoraId: PropTypes.string,
  isRightRailActive: PropTypes.bool,
};

export default ArtistLatestReleaseGridItem;
